import React, { useState, useEffect } from 'react';
import Sidebar from '../components/Sidebar';
import Table from '../components/Table';
import ModalAddProduct from '../components/ModalAddProduct';
import ModalEditProduct from '../components/ModalEditProduct';
import ModalDelete from '../components/ModalDelete';
import BlackButton from '../Utils/BlackButton';
import SearchBar from '../components/Searchbar';

//const IP = "http://143.110.239.79:5010/"
const IP = "https://pepetoys-backend.mindnt.com.mx/api/"
//const IP = "http://localhost:5010/"

const Productos = ({ onMenuSelect, onLogout }) => {
  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);
  const [productToEdit, setProductToEdit] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState('productos');
  const [isLoading, setIsLoading] = useState(false);

  // Filter products based on search term
  useEffect(() => {
    if (!searchTerm.trim()) {
      setFilteredProducts(products);
    } else {
      const filtered = products.filter(product =>
        product.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.description?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.atributo_1?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        product.atributo_2?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredProducts(filtered);
    }
  }, [products, searchTerm]);

  // Fetch categories from API
  const fetchCategories = async () => {
    try {
      const response = await fetch(`${IP}items/categories`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setCategories(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  // Fetch products from API
  const fetchProducts = async () => {
    setIsLoading(true);
    try {
      const response = await fetch(`${IP}items/get-items`);
      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          setProducts(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching products:', error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    fetchCategories();
  }, []); // Empty dependency array - only runs once on mount

  const handleDeleteProduct = (productId) => {
    const product = products.find(p => p.id === productId);
    setProductToDelete(product);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      const response = await fetch(`${IP}items/delete-item?item_id=${productToDelete.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.ok) {
        // Cerrar modal
        setShowDeleteModal(false);
        setProductToDelete(null);

        // Refrescar la lista de productos desde la API
        fetchProducts();
      } else {
        throw new Error('Error al eliminar el producto');
      }
    } catch (error) {
      console.error('Error deleting product:', error);
      // Opcional: mostrar mensaje de error al usuario
    }
  };

  const handleAddProduct = (newProduct) => {
    // Cerrar modal
    setShowAddModal(false);

    // Refrescar la lista de productos desde la API
    fetchProducts();
  };

  const handleEditProduct = (product) => {
    setProductToEdit(product.id);
    setShowEditModal(true);
  };

  const handleSaveEdit = async (updatedProduct) => {
    try {
      const requestBody = {
        img_item: updatedProduct.img_item,
        name: updatedProduct.name,
        description: updatedProduct.description,
        category_ids: updatedProduct.category_ids,
        images: updatedProduct.images || [],
        price: updatedProduct.price,
        atributo_1: updatedProduct.atributo_1,
        atributo_2: updatedProduct.atributo_2,
        product_counter_init: updatedProduct.product_counter_init,
        product_counter: updatedProduct.product_counter,
        apply_promotions: updatedProduct.apply_promotions,
        available_item: updatedProduct.available_item
      };

      console.log('Sending request body:', requestBody);

      const response = await fetch(`${IP}items/update-item-data?item_id=${updatedProduct.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(requestBody)
      });

      if (response.ok) {
        const result = await response.json();
        if (result.status === 'success') {
          console.log('Product updated successfully');
        }
      } else {
        throw new Error('Error updating product');
      }

      setShowEditModal(false);
      setProductToEdit(null);

      // Refresh products from API after edit
      fetchProducts();
    } catch (error) {
      console.error('Error saving product:', error);
    }
  };

  const handleMenuSelect = (menuId) => {
    setSelectedMenu(menuId);
    if (onMenuSelect) {
      onMenuSelect(menuId);
    }
  };

  // Helper: obtiene nombres de categorías a partir de un array de IDs o un solo ID (compatibilidad)
  const getCategoryNames = (categoryIdsOrId) => {
    if (!categoryIdsOrId && categoryIdsOrId !== 0) return [];
    const ids = Array.isArray(categoryIdsOrId) ? categoryIdsOrId : [categoryIdsOrId];
    return ids.map(id => {
      const cat = categories.find(c => c.id === id);
      return cat ? cat.name : `#${id}`;
    });
  };

  const columns = [
    { key: 'name', title: 'Nombre', width: '200px' },
    {
      key: 'price',
      title: 'Precio',
      align: 'right',
      render: (value) => `$${value.toFixed(2)}`
    },
    { key: 'description', title: 'Descripción', width: '200px' },
    {
      key: 'category_ids',
      title: 'Categorías',
      width: '200px',
      render: (value, item) => {
        // Soporta category_ids (array) o category_id (legado) en la respuesta del API
        const ids = value ?? (item.category_id != null ? [item.category_id] : []);
        const names = getCategoryNames(ids);
        if (names.length === 0) return <span className="text-gray-400 text-xs">Sin categoría</span>;
        return (
          <div className="flex flex-wrap gap-1">
            {names.map((name, i) => (
              <span key={i} className="px-2 py-0.5 bg-blue-100 text-blue-800 text-xs rounded-full whitespace-nowrap">
                {name}
              </span>
            ))}
          </div>
        );
      }
    },
    {
      key: 'atributo_1',
      title: 'Atributo 1',
      width: '150px',
      render: (value) => value || <span className="text-gray-400 text-sm">Sin valor</span>
    },
    {
      key: 'atributo_2',
      title: 'Atributo 2',
      width: '150px',
      render: (value) => value || <span className="text-gray-400 text-sm">Sin valor</span>
    },
    {
      key: 'product_counter_init',
      title: 'Contador Inicial',
      width: '120px',
      align: 'center',
      render: (value) => value !== null && value !== undefined ? value : <span className="text-gray-400 text-sm">Sin valor</span>
    },
    {
      key: 'product_counter',
      title: 'Contador Actual',
      width: '120px',
      align: 'center',
      render: (value) => value !== null && value !== undefined ? value : <span className="text-gray-400 text-sm">Sin valor</span>
    },
    {
      key: 'apply_promotions',
      title: 'Aplica Promociones',
      width: '140px',
      align: 'center',
      render: (value) => (
        <span className={`px-2 py-1 text-xs rounded-full ${value === 1 || value === true
          ? 'bg-green-100 text-green-800'
          : 'bg-red-100 text-red-800'
          }`}>
          {value === 1 || value === true ? 'Sí' : 'No'}
        </span>
      )
    },
    {
      key: 'img_item',
      title: 'Imagen URL',
      align: 'left',
      width: '250px',
      render: (value) => {
        if (!value) {
          return <span className="text-gray-400 text-sm">Sin imagen</span>;
        }

        const truncatedUrl = value.length > 40 ? `${value.substring(0, 40)}...` : value;

        return (
          <div className="flex items-center space-x-2">
            <span
              className="text-blue-600 text-sm cursor-pointer hover:underline truncate max-w-[150px]"
              title={value}
              onClick={() => window.open(value, '_blank')}
            >
              {truncatedUrl}
            </span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                navigator.clipboard.writeText(value).then(() => {
                  // Simple feedback without DOM manipulation
                  console.log('URL copied to clipboard');
                });
              }}
              className="text-gray-500 hover:text-gray-700 p-1"
              title="Copiar URL"
            >
              <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </button>
          </div>
        );
      }
    },
    {
      key: 'acciones',
      title: 'Acciones',
      align: 'center',
      width: '120px',
      render: (_, item) => (
        <div className="flex space-x-2 justify-center">
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleEditProduct(item);
            }}
            className="text-blue-500 hover:text-blue-700 transition-colors p-1"
            title="Editar producto"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
          <button
            onClick={(e) => {
              e.stopPropagation();
              handleDeleteProduct(item.id);
            }}
            className="text-red-500 hover:text-red-700 transition-colors p-1"
            title="Eliminar producto"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      )
    }
  ];

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar
        onMenuSelect={handleMenuSelect}
        activeMenu={selectedMenu}
        onLogout={onLogout}
      />

      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <header className="bg-white shadow-sm border-b border-gray-200 px-6 py-4">
          <div className="flex justify-between items-center">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Productos</h1>
              <p className="text-gray-600 mt-1">Administra tu catálogo de productos</p>
            </div>
            <div className="flex items-center space-x-4">
              <SearchBar
                value={searchTerm}
                onChange={setSearchTerm}
                placeholder="Buscar productos..."
                className="w-80"
                disabled={isLoading}
              />
              <BlackButton onClick={() => setShowAddModal(true)}>
                + Agregar Producto
              </BlackButton>
            </div>
          </div>
        </header>

        {/* Content */}
        <main className="flex-1 overflow-auto p-6">
          <div className="bg-white rounded-lg shadow-sm">
            {isLoading ? (
              <div className="flex justify-center items-center py-8">
                <div className="text-gray-500">Cargando productos...</div>
              </div>
            ) : (
              <>
                {searchTerm && (
                  <div className="px-6 py-3 border-b border-gray-200 bg-gray-50">
                    <p className="text-sm text-gray-600">
                      {filteredProducts.length} resultado(s) para "{searchTerm}"
                      {filteredProducts.length !== products.length && (
                        <span className="ml-2 text-gray-500">
                          de {products.length} total(es)
                        </span>
                      )}
                    </p>
                  </div>
                )}
                <Table
                  columns={columns}
                  data={filteredProducts}
                  emptyMessage={
                    searchTerm
                      ? `No se encontraron productos que coincidan con "${searchTerm}"`
                      : "No hay productos disponibles"
                  }
                />
              </>
            )}
          </div>
        </main>
      </div>

      {/* Modals */}
      {showAddModal && (
        <ModalAddProduct
          isOpen={showAddModal}
          onClose={() => setShowAddModal(false)}
          onSave={handleAddProduct}
        />
      )}

      {showEditModal && (
        <ModalEditProduct
          isOpen={showEditModal}
          onClose={() => {
            setShowEditModal(false);
            setProductToEdit(null);
          }}
          onSave={handleSaveEdit}
          productId={productToEdit}
        />
      )}

      {showDeleteModal && (
        <ModalDelete
          isOpen={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onConfirm={confirmDelete}
          productName={productToDelete?.name}
        />
      )}
    </div>
  );
};

export default Productos;